import script from "./ColumnRightSide.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnRightSide.vue?vue&type=script&setup=true&lang=js"

import "./ColumnRightSide.vue?vue&type=style&index=0&id=7468d637&lang=scss"

const __exports__ = script;

export default __exports__